import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

const STORAGE_NAME = 'user';
export const useUserStore = defineStore('user', () => {
  const user = ref(localStorage.getItem(STORAGE_NAME));

  const getUser = computed(() => user.value);
  const setUser = (val: string) => {
    user.value = val;
    localStorage.setItem(STORAGE_NAME, val);
  };

  const deleteUser = () => {
    user.value = null;
    localStorage.removeItem(STORAGE_NAME);
  };

  return { getUser, setUser, deleteUser };
});
